import { ProductDTO, ProductLightExtendedDTO } from '@addsome/dtos'

export default function getProductName(product: ProductDTO | ProductLightExtendedDTO) {
  return `${product.name}${product.details ? ` | ${product.details}` : ''}`
}
